import React, { Fragment } from 'react';
import { string, shape, arrayOf } from 'prop-types';

import { BrandSimpleCard } from '../../cards';

const Menu = ({ cards, links }) => {
    if ((!cards || !cards.length) && (!links || !links.length)) {
        return null;
    }

    return (
        <Fragment>
            {cards && !!cards.length && (
                <div className="c-search__menu-block">
                    <div className="grid grid--cards grid--equal-height">
                        {cards.map(({ id, url, title, target, icon }) => (
                            <div key={id} className="col-md-6 col-lg-4">
                                <BrandSimpleCard
                                    bigTitle
                                    url={url}
                                    target={target}
                                    title={title}
                                    topIcon={icon}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {links && !!links.length && (
                <div className="c-search__menu-block c-search__menu-block--links">
                    <ul className="grid c-search__menu-links">
                        {links.map(({ id, url, title, target }) => (
                            <li key={id} className="col-6 col-md-4 col-lg-2">
                                <a className="link" href={url} target={target}>
                                    {title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </Fragment>
    );
};

Menu.propTypes = {
    cards: arrayOf(
        shape({
            id: string,
            icon: string,
            target: string,
            title: string,
            url: string
        })
    ),
    links: arrayOf(
        shape({ id: string, target: string, title: string, url: string })
    )
};

export default Menu;
